var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuOpciones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_10_1",
    "data-name": "Componente 10 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_75",
    "data-name": "Rect\\xE1ngulo 75",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "more_vert_FILL0_wght300_GRAD0_opsz40",
    d: "M437.274-749.986a1.518,1.518,0,0,1-1.117-.466,1.532,1.532,0,0,1-.463-1.12,1.533,1.533,0,0,1,.466-1.122,1.524,1.524,0,0,1,1.12-.468,1.513,1.513,0,0,1,1.117.469,1.546,1.546,0,0,1,.463,1.127,1.517,1.517,0,0,1-.466,1.117A1.533,1.533,0,0,1,437.274-749.986Zm0-8.807a1.518,1.518,0,0,1-1.117-.466,1.533,1.533,0,0,1-.463-1.12,1.518,1.518,0,0,1,.466-1.117,1.532,1.532,0,0,1,1.12-.463,1.518,1.518,0,0,1,1.117.466,1.533,1.533,0,0,1,.463,1.12,1.518,1.518,0,0,1-.466,1.117A1.532,1.532,0,0,1,437.274-758.793Zm0-8.8a1.514,1.514,0,0,1-1.117-.469,1.546,1.546,0,0,1-.463-1.127,1.517,1.517,0,0,1,.466-1.117,1.533,1.533,0,0,1,1.12-.463,1.518,1.518,0,0,1,1.117.466,1.532,1.532,0,0,1,.463,1.12,1.533,1.533,0,0,1-.466,1.122A1.525,1.525,0,0,1,437.274-767.591Z",
    transform: "translate(-424.277 772.767)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpciones);
export default __webpack_public_path__ + "static/media/menu-opciones.79e629c8a2c27ab64389a846074bebc7.svg";
export { ForwardRef as ReactComponent };